import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useThemeContext } from '../contexts/ThemeContext';
import { useConfigContext } from '../contexts/ConfigContext';
import ContentViewer from '../components/ContentViewer';
import { getPostContent } from '../services/contentService';
import './PostPage.css';

function PostPage() {
  const { slug } = useParams();
  const { theme, toggleTheme } = useThemeContext();
  const { config } = useConfigContext();

  // Update document title when post changes
  useEffect(() => {
    if (!slug) {
      // Set default title
      if (config?.siteTitle) {
        document.title = config.siteTitle;
      }
      return;
    }

    // Load post and set title
    getPostContent(slug)
      .then(post => {
        const siteTitle = config?.siteTitle || 'Sutra';
        document.title = `${post.title} | ${siteTitle}`;
      })
      .catch(err => {
        console.error('Failed to load post for title:', err);
        if (config?.siteTitle) {
          document.title = config.siteTitle;
        }
      });
  }, [slug, config]);

  return (
    <div className="post-page" data-theme={theme}>
      <header className="post-page-header">
        <div className="post-page-header-content">
          <Link to="/" className="post-page-logo">
            {config?.branding?.text || 'Sutra'}
          </Link>

          <button
            className="post-page-theme-toggle"
            onClick={toggleTheme}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            aria-label="Toggle theme"
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
        </div>
      </header>

      <main className="post-page-main">
        <ContentViewer slug={slug} />
      </main>

      <footer className="post-page-footer">
        <div className="post-page-footer-content">
          <Link to="/" className="post-page-footer-link">
            ← Back to all posts
          </Link>

          <div className="post-page-footer-info">
            Built with <a href={config?.about?.githubUrl || "https://github.com/yourusername/sutra"} target="_blank" rel="noopener noreferrer">{config?.branding?.text || 'Sutra'}</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PostPage;
